customElements.define(
  "announcement-bar",
  class extends HTMLElement {
    connectedCallback() {
      const template = this.querySelector(".announcement-source");
      if (!template) return;
      this.sourceItems = [
        ...template.content.querySelectorAll(".announcement-item")
      ];
      this.desktopContainer = this.querySelector(".announcement-desktop");
      this.mobileTrack = this.querySelector(".announcement-track");
      this.speed = (parseInt(this.dataset.speed, 10) || 4) * 1e3;
      this.render();
      this.startCountdowns();
      this.listenForCartUpdates();
    }
    disconnectedCallback() {
      clearInterval(this.rotationInterval);
      clearInterval(this.countdownInterval);
    }
    getActiveItems() {
      const now = Date.now();
      return this.sourceItems.filter((item) => {
        if (item.dataset.type === "countdown") {
          return new Date(item.dataset.endDate).getTime() > now;
        }
        return true;
      });
    }
    render() {
      clearInterval(this.rotationInterval);
      const items = this.getActiveItems();
      if (items.length === 0) {
        this.style.display = "none";
        clearInterval(this.countdownInterval);
        return;
      }
      this.style.display = "";
      this.renderDesktop(items);
      this.renderMobile(items);
      this.updateCountdownDisplays();
      this.updateShippingDisplays();
    }
    renderDesktop(items) {
      this.desktopContainer.innerHTML = "";
      items.forEach((item, i) => {
        const span = document.createElement("span");
        span.className = "announcement-message absolute inset-0 flex items-center justify-center transition-opacity duration-500";
        if (i > 0) span.classList.add("opacity-0");
        span.innerHTML = item.innerHTML || item.textContent;
        this.copyData(item, span);
        this.desktopContainer.appendChild(span);
      });
      const spacer = document.createElement("span");
      spacer.className = "invisible";
      spacer.textContent = items[0].textContent || " ";
      this.desktopContainer.appendChild(spacer);
      this.desktopMessages = this.desktopContainer.querySelectorAll(".announcement-message");
      this.current = 0;
      if (this.desktopMessages.length > 1) {
        this.rotationInterval = setInterval(() => this.rotate(), this.speed);
      }
    }
    renderMobile(items) {
      this.mobileTrack.innerHTML = "";
      for (let r = 0; r < 3; r++) {
        items.forEach((item) => {
          const span = document.createElement("span");
          span.className = "pr-16";
          span.innerHTML = item.innerHTML || item.textContent;
          this.copyData(item, span);
          this.mobileTrack.appendChild(span);
        });
      }
      this.mobileTrack.style.animation = "none";
      this.mobileTrack.offsetHeight;
      this.mobileTrack.style.animation = "";
      const thirdWidth = this.mobileTrack.scrollWidth / 3;
      const duration = thirdWidth / 40;
      this.mobileTrack.style.setProperty("--marquee-duration", `${duration}s`);
      this.mobileTrack.style.setProperty("--marquee-state", "running");
    }
    copyData(from, to) {
      for (const [key, val] of Object.entries(from.dataset)) {
        to.dataset[key] = val;
      }
    }
    rotate() {
      this.desktopMessages[this.current].classList.add("opacity-0");
      this.current = (this.current + 1) % this.desktopMessages.length;
      this.desktopMessages[this.current].classList.remove("opacity-0");
    }
    startCountdowns() {
      const hasCountdowns = this.sourceItems.some(
        (item) => item.dataset.type === "countdown"
      );
      if (!hasCountdowns) return;
      this.countdownInterval = setInterval(() => {
        this.updateCountdownDisplays();
        const now = Date.now();
        const hasExpired = this.sourceItems.some(
          (item) => item.dataset.type === "countdown" && new Date(item.dataset.endDate).getTime() <= now
        );
        if (hasExpired) {
          this.sourceItems = this.sourceItems.filter((item) => {
            if (item.dataset.type !== "countdown") return true;
            return new Date(item.dataset.endDate).getTime() > now;
          });
          this.render();
          if (!this.sourceItems.some((item) => item.dataset.type === "countdown")) {
            clearInterval(this.countdownInterval);
          }
        }
      }, 1e3);
    }
    updateCountdownDisplays() {
      const now = Date.now();
      this.querySelectorAll('[data-type="countdown"]').forEach((el) => {
        const diff = new Date(el.dataset.endDate).getTime() - now;
        if (diff <= 0) return;
        const d = Math.floor(diff / 864e5);
        const h = Math.floor(diff % 864e5 / 36e5);
        const m = Math.floor(diff % 36e5 / 6e4);
        const s = Math.floor(diff % 6e4 / 1e3);
        let timeStr = "";
        if (d > 0) timeStr += `${d}d `;
        timeStr += `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
        el.textContent = (el.dataset.message || "").replace("{timer}", timeStr);
      });
    }
    listenForCartUpdates() {
      const hasShipping = this.sourceItems.some(
        (item) => item.dataset.type === "shipping"
      );
      if (!hasShipping) return;
      ["cart:updated", "cart:change"].forEach((evt) => {
        document.addEventListener(evt, () => this.updateShippingDisplays());
      });
      document.addEventListener("product:added-to-cart", () => {
        setTimeout(() => this.updateShippingDisplays(), 300);
      });
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        new MutationObserver((mutations) => {
          for (const m of mutations) {
            if (m.attributeName === "class" && cartDrawer.classList.contains("active")) {
              this.updateShippingDisplays();
              break;
            }
          }
        }).observe(cartDrawer, { attributes: true, attributeFilter: ["class"] });
      }
    }
    async updateShippingDisplays() {
      const shippingEls = this.querySelectorAll('[data-type="shipping"]');
      if (shippingEls.length === 0) return;
      try {
        const res = await fetch("/cart.js");
        const cart = await res.json();
        shippingEls.forEach((el) => {
          const threshold = parseInt(el.dataset.threshold) || 0;
          const converted = this.convertThreshold(threshold);
          const remaining = converted - cart.total_price;
          let text;
          if (cart.item_count === 0) {
            text = (el.dataset.emptyText || "").replace(
              "{remaining}",
              this.formatMoney(converted)
            );
          } else if (remaining <= 0) {
            text = el.dataset.achievedText || "";
          } else {
            text = (el.dataset.text || "").replace(
              "{remaining}",
              this.formatMoney(remaining)
            );
          }
          el.textContent = text;
        });
      } catch (e) {
        console.error("Error updating shipping:", e);
      }
    }
    convertThreshold(threshold) {
      const rate = window.Shopify?.currency?.rate;
      if (rate && parseFloat(rate) !== 1) {
        return Math.round(threshold * parseFloat(rate));
      }
      return threshold;
    }
    formatMoney(cents) {
      if (isNaN(cents) || cents == null) cents = 0;
      if (window.money_format) {
        const amount = (cents / 100).toFixed(2);
        const noDecimals = Math.floor(cents / 100).toString();
        const commaSep = amount.replace(".", ",");
        return window.money_format.replace(/\{\{\s*amount\s*\}\}/g, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals).replace(
          /\{\{\s*amount_with_comma_separator\s*\}\}/g,
          commaSep
        );
      }
      const currency = window.Shopify?.currency?.active || "USD";
      const locale = navigator.language || "en-US";
      try {
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(cents / 100);
      } catch {
        return `$${(cents / 100).toFixed(2)}`;
      }
    }
  }
);
